import styles from "./index.module.less";
import closeIcon from "./close.png";
import modalCloseIcon from "./close.png";
import classNames from "classnames";
import { useState } from "react";
const VideoModal = ({
  open,
  url,
  onClose,
}: {
  open?: boolean;
  url?: string;
  onClose?: () => void;
}) => {
  const [closing, setClosing] = useState(false);
  if (!open) return null;
  const handleClose = () => {
    setClosing(true);
    setTimeout(() => {
      onClose?.();
    }, 300);
  };
  return (
    <div className={styles.videoModal}>
      <div
        className={styles.mask}
        onClick={onClose}
      ></div>
      <div
        className={classNames(styles.body, {
          [styles.fadeOut]: closing,
          [styles.fadeIn]: !closing,
        })}
      >
        <video src={url} controls autoPlay />
        <div className={styles.close} onClick={onClose}>
          <img src={modalCloseIcon} />
        </div>
      </div>
    </div>
  );
};
export default VideoModal;
